/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_Change_AreaInputs */

const vi_grower_area_qr_change_area = /** @type {(inputs: Grower_Area_Qr_Change_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vùng khác`)
};

/**

* @param {Grower_Area_Qr_Change_AreaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_change_area = /** @type {((inputs?: Grower_Area_Qr_Change_AreaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_Change_AreaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_change_area(inputs)
});